import React from 'react';
import classNames from 'classnames';

import css from './Topbar.module.css';

/**
 * Menu icon (hamburger icon)
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} menu icon
 */
const MenuIcon = props => {
  const { className, rootClassName, ariaLabel } = props;
  const classes = classNames(rootClassName || css.rootMenuIcon, className);

  return (
    <>
      <svg
        className={classes}
        role="img"
        aria-label={ariaLabel}
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M7.33008 16H24.6702"
          stroke="#FFFEF4"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.33008 21.3355H24.6702"
          stroke="#FFFEF4"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.33008 10.6644H24.6702"
          stroke="#FFFEF4"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export default MenuIcon;
